<div [class.loader-hidden]="!show">
    <div class="overlay_wrapper">
        <div class="segmentstabinnerloader">
            <img src="assets/img/page-loader.gif">
        </div>
    </div>
</div>